import http from 'common/http'
import { closeModal } from 'actions/app'
import {
  operatorsFetched,
  operatorCreated,
  operatorEdited,
  operatorDeleted,
} from 'actions/operator'

export const fetchOperators = () => {
  return (dispatch) => {
    return http.get('/operator').then((res) => {
      dispatch(operatorsFetched(res.data))
    })
  }
}

export const createOperator = (data) => {
  return (dispatch) => {
    return http.post('/operator', data).then((res) => {
      dispatch(closeModal())
      dispatch(operatorCreated(res.data))
    })
  }
}

export const editOperator = (operatorId, data) => {
  return (dispatch) => {
    return http.put(`/operator/${operatorId}`, data).then((res) => {
      dispatch(closeModal())
      dispatch(operatorEdited(res.data))
    })
  }
}

export const deleteOperator = (operatorId) => {
  return (dispatch) => {
    return http.delete(`/operator/${operatorId}`).then((res) => {
      dispatch(closeModal())
      dispatch(operatorDeleted(operatorId))
    })
  }
}
